import { render } from "./OutlineGivings.vue?vue&type=template&id=9b3cce38"
import script from "./OutlineGivings.vue?vue&type=script&lang=js"
export * from "./OutlineGivings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__